export default "__VITE_PUBLIC_ASSET__8d75866a__"